"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _ImageComponent = _interopRequireDefault(require("./ImageComponent"));

var _VideoComponent = _interopRequireDefault(require("./VideoComponent"));

var useStyles = (0, _styles.makeStyles)(function () {
  return (
    /* theme */
    {
      root: {
        width: '100%'
      }
    }
  );
}, {
  name: 'SxComMediaSelectorBanner'
});
var mediaTypeComponents = {
  image: _ImageComponent.default,
  video: _VideoComponent.default
};

function MediaSelectorBanner(_ref) {
  var active = _ref.active,
      alt = _ref.alt,
      pClasses = _ref.classes,
      className = _ref.className,
      href = _ref.href,
      size = _ref.size,
      src = _ref.src,
      type = _ref.type,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["active", "alt", "classes", "className", "href", "size", "src", "type"]);
  var classes = useStyles({
    classes: pClasses
  });
  var Component = mediaTypeComponents[type || 'image'];
  var t = (0, _useTranslate.default)();

  var handleRedirect = _react.default.useCallback(function () {
    if (typeof window !== 'undefined' && href) {
      window.open(href, '_blank');
    }
  }, [href]);

  if (!Component) {
    // eslint-disable-next-line no-console
    console.warn("WARNING: a component for media type `".concat(type, "` not defined."));
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, rest, {
    onClick: handleRedirect,
    className: (0, _clsx.default)(classes.root, className),
    alt: alt ? t(alt, {
      acceptString: true
    }) : '',
    src: src,
    size: size
  }));
}

process.env.NODE_ENV !== "production" ? MediaSelectorBanner.propTypes = {
  active: _propTypes.default.bool,
  alt: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.shape({
    language: _propTypes.default.string.isRequired,
    text: _propTypes.default.string
  }))]),
  classes: _propTypes.default.shape({
    image: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  href: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['square', 'small-square', 'banner', 'leaderboard', 'inline-rectangle', 'large-rectangle', 'skyscraper', 'wide-skyscraper', 'half-page-ad', 'large-leaderboard']), _propTypes.default.string]).isRequired,
  src: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.string))]).isRequired,
  type: _propTypes.default.oneOf(Object.keys(mediaTypeComponents))
} : void 0;
MediaSelectorBanner.defaultProps = {
  active: undefined,
  alt: undefined,
  classes: undefined,
  className: undefined,
  href: undefined,
  type: undefined
};
var _default = MediaSelectorBanner;
exports.default = _default;